import { authOptionsSchema, meResponseSchema } from "@repro/shared";
import { queryOptions } from "@tanstack/react-query";
import { z } from "zod";
import { api } from "../../lib/api-client";

const AUTH = "/api/auth";

export const authKeys = {
  me: ["me"] as const,
  options: ["auth-options"] as const,
};

export const meQuery = queryOptions({
  queryKey: authKeys.me,
  queryFn: () => api("/me", { schema: meResponseSchema }),
  staleTime: 60_000,
});

export const authOptionsQuery = queryOptions({
  queryKey: authKeys.options,
  queryFn: () => api("/auth-options", { schema: authOptionsSchema }),
  staleTime: Number.POSITIVE_INFINITY,
});

const ok = z.unknown();

export function signIn(input: { email: string; password: string }) {
  return api(`${AUTH}/sign-in/email`, { method: "POST", body: input, schema: ok });
}

export function signUp(input: { name: string; email: string; password: string }) {
  return api(`${AUTH}/sign-up/email`, { method: "POST", body: input, schema: ok });
}

export function signOut() {
  return api(`${AUTH}/sign-out`, { method: "POST", body: {}, schema: ok });
}

export function signOutEverywhere() {
  return api(`${AUTH}/revoke-sessions`, { method: "POST", body: {}, schema: ok });
}

export function requestPasswordReset(email: string) {
  return api(`${AUTH}/request-password-reset`, {
    method: "POST",
    body: { email, redirectTo: `${window.location.origin}/reset-password` },
    schema: ok,
  });
}

export function resetPassword(token: string, newPassword: string) {
  return api(`${AUTH}/reset-password`, {
    method: "POST",
    body: { token, newPassword },
    schema: ok,
  });
}

/** Google sign-in: better-auth answers with the provider URL to send the browser to. */
export async function signInWithGoogle(callbackURL: string) {
  const result = await api(`${AUTH}/sign-in/social`, {
    method: "POST",
    // FR-ACC-08: a refused Google account comes back to sign-in with ?error=, not to a bare error page.
    body: {
      provider: "google",
      callbackURL,
      errorCallbackURL: `${window.location.origin}/sign-in`,
    },
    schema: z.object({ url: z.string().url() }),
  });
  window.location.assign(result.url);
}
